import script from "./ChooseGiftButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChooseGiftButton.vue?vue&type=script&setup=true&lang=ts"

import "./ChooseGiftButton.vue?vue&type=style&index=0&id=5fa16339&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fa16339"]])

export default __exports__